<template>
	<v-container v-if="show" grid-list-xl>
		<v-layout
			row
			justify-center
		>
			<v-flex
				xs12
				md8
				pa-0
			>
				<slot name="alert" />
			</v-flex>
		</v-layout>
<!--		<NewItem
			v-if="$userCan('manage_users') && !project.isArchived"
			ref="newItem"
			button-title="Invite New"
			:loading="sendingInvitation"
		>
			<template slot="form">
				<v-form
					ref="form"
					v-model="valid"
					@submit.prevent="submit"
				>
					<v-layout
						row
						wrap
						ma-0
						justify-center
						align-center
					>
						<v-flex
							xs12
							sm9
							py-0
						>
							<v-text-field
								:disabled="sendingInvitation"
								v-model="inviteName"
								:rules="[...validate.require, validate.max(inviteName, 35)]"
								name="Name"
								label="Name"
							/>
							<v-text-field
								:disabled="sendingInvitation"
								v-model="inviteEmail"
								:rules="[validate.email]"
								name="Email"
								label="Email"
							/>
						</v-flex>
						<v-flex
							xs12
							sm3
							class="text-xs-center"
						>
							<v-btn
								:disabled="!valid || sendingInvitation"
								color="primary"
								type="submit"
							>
								submit
							</v-btn>
							<v-btn
								:disabled="sendingInvitation"
								flat
								color="error"
								@click="$refs.newItem.close()"
							>
								Close
							</v-btn>
						</v-flex>
					</v-layout>
				</v-form>
			</template>
		</NewItem>-->
		<v-layout
			v-if="this.$userCan('super')"
			row
			justify-center
		>
			<v-flex
				xs12
				md8
				pa-2
			>
				<div class="superUser pt-1 px-2">
					<v-autocomplete
						v-model="accountId"
						:items="accounts"
						xxxrules="[validation]"
						xxxfilter="autocompleteFilter"
						item-text="name"
						item-value="id"
						label="Account"
					/>
				</div>
			</v-flex>
		</v-layout>
		<v-data-table
			:headers="headers"
			:items="users"
			:loading="users.length === 0"
			:hide-actions="true"
			class="elevation-2"
		>
			<template slot="items" slot-scope="props">
				<td>
					<div class="title">
						{{ props.item.realName }}
					</div>
					<div class="caption" v-if="props.item.email !== props.item.realName">
						<span class="caption" v-if="props.item.external">[external]</span> {{ props.item.email }}
					</div>
				</td>
				<td>
					{{ fromNow(props.item.registration) }}
				</td>
				<td>
					{{ fromNow(props.item.lastLogin) }}
				</td>
				<td>
					<em v-if="!props.item.projectAccessInAccount">No projects</em>
					<template
						v-else-if="projectsTrim && props.item.projectAccessInAccount.length > projectsTrimNum"
					>
						<div
							v-for="project in props.item.projectAccessInAccount.slice(0, projectsTrimNum-1)"
							:key="project.id"
						>
							<strong>{{project.name}}</strong>
						</div>
						<div>
							<a @click.prevent="showAllProjects">
								and {{ props.item.projectAccessInAccount.length - projectsTrimNum - 1 }} more
							</a>
						</div>
					</template>
					<template v-else>
						<div v-for="project in props.item.projectAccessInAccount" :key="project.id">
							<strong>{{project.name}}</strong>
						</div>
					</template>
				</td>
				<td
					v-if="$userCan('super')"
					class="pa-0 text-xs-center"
				>
					<v-btn
						icon
						flat
						color="success"
						@click="showEdit(props.item)"
					>
						<v-icon>edit</v-icon>
					</v-btn>
				</td>
			</template>
		</v-data-table>
<!--		<UserIterator :items="users" />-->
		<Confirm ref="confirm"/>
		<Dialog
			v-if="this.selectedUser"
			:title="`Set projects for ${this.selectedUser.realName}`"
			:show="showEditProjectsDialog"
			@close="showEditProjectsDialog = false"
		>
			<template slot="content">
				<div
					v-for="project in projects"
					:key="project.id"
				>
					<v-checkbox
						v-model="project.selected"
						:label="project.name"
						hide-details
						color="primary"
						class="ma-0"
					/>
				</div>
			</template>
			<template slot="buttons">
				<v-btn
					flat
					color="success"
					@click="updateUserProjects"
				>
					Save
				</v-btn>
			</template>
		</Dialog>
	</v-container>
</template>

<script>
import { User } from '@/models/User';
import UserIterator from '@/components/Settings/UserIterator';
import NewItem from '@/components/NewItem';
import Confirm from '@/components/Confirm';
import Dialog from '@/components/Global/Dialog';
import Validation from '@/mixins/Validation';
import axios from '@/util/axios';
import moment from 'moment';
import { Accounts } from '@/models/Account';

export default {
	components: {
		// UserIterator,
		// NewItem,
		Confirm,
		Dialog,
	},
	mixins: [Validation],
	data() {
		return {
			show: false,
			projectsTrim: true,
			projectsTrimNum: 3,
			// valid: true,
			// inviteName: '',
			// inviteEmail: '',
			// sendingInvitation: false,
			accounts: [],
			users: [],
			accountId: -1,
			showEditProjectsDialog: false,
			projects: [],
			selectedUser: null,
			headers: [
				{
					text: 'Name',
					value: 'realName',
				},
				{
					text: 'Registration',
					value: 'registration',
				},
				{
					text: 'Last Login',
					value: 'lastLogin',
				},
				{
					text: 'Projects',
					sortable: false,
				},
				{
					text: 'Actions',
					sortable: false,
					align: 'center',
				},
			],
		};
	},
	created() {
		// Redirect to not found if user doesn't have permission to settings
		this.show = this.$userCan('account_owner');
		if (!this.show) {
			this.$router.replace({ name: 'NotFound' });
		}

		this.accountId = this.$ls.get('accountId', -1);
		// this.fetchUsers(); // watch does this now
		if (this.$userCan('super')) {
			this.fetchAccounts();
		}
	},
	mounted() {
	},
	computed: {
	},
	methods: {
		submit() {
			this.sendingInvitation = true;

			const user = new User();
			user.invite(this.project.id, this.inviteName, this.inviteEmail).then((r) => {
				this.$notify('success', `Invitation sent to ${this.inviteName}.`);
				this.$refs.form.reset();
				this.$refs.newItem.close();
				/** @todo Refresh users list if user exists */
			}).catch((e) => {
				dump(e);
				this.$notify('error', 'Error on sending email.');
			}).finally(() => {
				this.sendingInvitation = false;
			});
		},
		updateUser(accessLevel, user) {
			user.access = accessLevel;
			let text = '';
			const userLevel = User.userLevels.find(level => level.value === accessLevel);
			if (userLevel.label) {
				text = `Change ${user.realName}'s access level to "${userLevel.label}"`;
			}

			this.$refs.confirm.createConfirm('Save user changes?', 'success', text).then((answer) => {
				if (!answer) {
					return;
				}
				user.saving = true;
				this.project.updateUser(user.id, user.access).then(() => {
					this.$notify('success', 'User updated.');
				}).catch((e) => {
					dump(e);
					this.$notify('error', 'Error while updating user.');
				}).finally(() => {
					user.saving = false;
				});
			});
		},
		fromNow(timestamp) {
			if (['', '0000-00-00 00:00:00'].includes(timestamp)) {
				return 'Never';
			}
			return moment(`${timestamp}Z`).fromNow();
		},
		showAllProjects() {
			this.projectsTrim = false;
		},
		fetchAccounts() {
			const accounts = new Accounts();
			accounts.fetch().then(() => {
				this.accounts = accounts.visibleModels;
			}).catch((e) => {
				dump('Error fetching accounts', e);
				this.$notify('error', 'Failed to get accounts, refresh to try again.');
			});
		},
		fetchUsers() {
			this.users = [];
			axios.get(`/accounts/${this.accountId}/users`)
				.then((resp) => {
					this.users = resp.data;
				})
				.catch((e) => {
					this.$notify('error', 'Failed to retrieve users.');
				});
		},
		fetchProjectsForAccount() {
			axios.get(`/accounts/${this.accountId}/projects`).then((resp) => {
				this.projects = resp.data;
			}).catch((e) => {
				this.$notify('error', 'Failed to retrieve projects.');
			});
		},
		showEdit(item) {
			this.showEditProjectsDialog = true;
			this.selectedUser = item;
			this.projects.map((project) => {
				const hasCurrentAccess = item.projectAccessInAccount.some((usersProject) => {
					return usersProject.id === parseInt(project.id);
				});
				project.selected = hasCurrentAccess;
			});
		},
		updateUserProjects() {
			this.showEditProjectsDialog = false;

			const data = {
				userId: this.selectedUser.id,
				projects: this.projects,
			};

			axios.put(`/accounts/${this.accountId}/user-access`, data).then((resp) => {
				this.$notify('success', 'User permissions updated successfully.');
				this.selectedUser.projectAccessInAccount = resp.data;
			}).catch((e) => {
				this.$notify('error', 'Failed to retrieve projects.');
			});
		},
	},
	watch: {
		accountId() {
			this.fetchUsers();
			if (this.$userCan('super')) {
				this.fetchProjectsForAccount();
			}
		},
	},
};
</script>
